import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const SquareArrowUpRightIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.5 3.33301C13.4998 2.87303 13.127 2.50018 12.667 2.5H3.33301C2.87303 2.50018 2.50018 2.87303 2.5 3.33301V12.667C2.50018 13.127 2.87303 13.4998 3.33301 13.5H12.667C13.127 13.4998 13.4998 13.127 13.5 12.667V3.33301ZM14.5 12.667C14.4998 13.6793 13.6793 14.4998 12.667 14.5H3.33301C2.32074 14.4998 1.50018 13.6793 1.5 12.667V3.33301C1.50018 2.32074 2.32074 1.50018 3.33301 1.5H12.667C13.6793 1.50018 14.4998 2.32074 14.5 3.33301V12.667Z"
      fill="currentColor"
    />
    <path
      d="M10.1664 10.6663V5.83334H5.33334C5.0572 5.83334 4.83334 5.60948 4.83334 5.33334C4.83334 5.05719 5.0572 4.83334 5.33334 4.83334H10.6664C10.9425 4.83334 11.1664 5.05719 11.1664 5.33334V10.6663C11.1664 10.9425 10.9425 11.1663 10.6664 11.1663C10.3904 11.1662 10.1664 10.9424 10.1664 10.6663Z"
      fill="currentColor"
    />
    <path
      d="M10.3128 4.97982C10.508 4.78461 10.8246 4.78472 11.0199 4.97982C11.2151 5.17508 11.2151 5.49158 11.0199 5.68685L5.68686 11.0199C5.4916 11.2151 5.17509 11.2151 4.97983 11.0199C4.78473 10.8246 4.78462 10.508 4.97983 10.3128L10.3128 4.97982Z"
      fill="currentColor"
    />
  </svg>
);
